import { fieldTypes, valueTypes } from '../../../types/common/commonTypes'
import { partFields, partState } from '../../../types/part/partTypes'

export const initialPartState: partState = {
    fields: [
        {
            field: partFields.PartBrand,
            fieldType: fieldTypes.selectSearch,
            valueType: valueTypes.string,
            value: '',
            title: 'Бренд запчасти',
            specialProps: {
                isRequired: true,
                placeholder: 'выберите бренд',
                column: 1,
            },
        },
    ],
}
